<template>
  <div>
    <v-dialog v-model="dialogData" width="500" persistent>
      <v-card>
        <v-card-title> Change Outlet to Merchant </v-card-title>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Nama Merchant </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  {{ editedItemData.nama_merchant }}
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Nama Outlet </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  {{ editedItemData.nama_outlet }}
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> MID </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  {{ editedItemData.mid }}
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> NMID </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  {{ editedItemData.nmid }}
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Alamat Lengkap </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  {{ editedItemData.address }}
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Kriteria Merchant </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  {{ editedItemData.merchant_criteria }}
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> Email </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  <v-text-field
                    id="email"
                    ref="email"
                    v-model="editedItemData.email"
                    @change="$v.editedItemData.email.$touch()"
                    @blur="$v.editedItemData.email.$touch()"
                    :error-messages="emailErrors"
                  />
                </v-col>
              </v-row>
              <v-row style="align-items: center">
                <v-col cols="10" sm="4"> No. Handphone </v-col>
                <v-col cols="2" sm="1"> : </v-col>
                <v-col cols="12" sm="7">
                  {{ editedItemData.mobile_phone }}
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="cancelDialog"> Cancel </v-btn>
          <v-btn
            color="primary"
            @click="confirm"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="500" persistent>
      <confirm-dialog
        :title="'Are you sure want to do this ?'"
        v-on:closeCancelParent="close"
        v-on:confirmParent="save"
      />
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { date, showAlert } from '../../lib/helpers';

export default {
  components: {
    confirmDialog: () => import('../ConfirmDialog.vue'),
  },
  props: {
    editedItem: {
      type: Object,
      default: null,
    },
    dialogOtoM: {
      type: Boolean,
      default: false,
    },
    editedIndex: {
      type: Number,
      default: null,
    },
  },
  mixins: [validationMixin],
  validations: {
    editedItemData: {
      email: {
        required,
        email,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.email == null ||
              this.errorValidation.email.length < 1)
          );
        },
      },
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    editedItemData: {
      get() {
        return this.editedItem;
      },
      set(newValue) {
        this.$emit('update:editedItem', newValue);
      },
    },
    dialogData() {
      return this.dialogOtoM;
    },
    errorValidation() {
      return this.$store.state.outletManagement.errors;
    },
    loading() {
      return this.$store.state.outletManagement.loading;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItemData.email.$dirty) return errors;
      if (!this.$v.editedItemData.email.email) {
        errors.push('Must be valid e-mail');
      }
      if (!this.$v.editedItemData.email.required) {
        errors.push('E-mail is required');
      }
      if (!this.$v.editedItemData.email.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.email != null
        ) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
  },
  watch: {
    'editedItemData.email': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit('outletManagement/clearErrorVariable', 'email');
          }
        }
      },
    },
  },
  methods: {
    cancelDialog() {
      this.$emit('closeCancelParent');
    },
    resetUniqueValidation() {
      this.$store.commit('outletManagement/clearErrors');
    },
    confirm() {
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.dialog = true;
      }
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.dialog = false;
      this.$store.commit('outletManagement/setFlashErrorMessage', '');

      const outlet = this.editedItemData;
      await this.$store
        .dispatch('outletManagement/updateOutlet', {
          date,
          outlet,
          index: this.editedItemData.id,
        })
        .then((status) => {
          if (status) {
            this.$emit('closeCancelParent');
            showAlert(
              this.$store,
              'Update outlet success !',
              'mdi-check-circle',
              'green'
            );
          } else {
            showAlert(
              this.$store,
              'Error on update outlet !',
              'mdi-alert',
              'red'
            );
          }
        });
    },
  },
};
</script>
